import { Component, OnInit,Input } from '@angular/core';


import { VaService } from '../_services/va.service';
import { SearchService } from '../_services/search.service';

import * as groupArray from 'group-array';

@Component({
  selector: 'app-trash',
  templateUrl: './trash.component.html',
  styleUrls: ['./trash.component.scss']
})
export class TrashComponent implements OnInit {

  @Input() searchText: String;



  groupedProjects = [];
  loadingStatus: boolean =  false;


  constructor(
    public vaService: VaService,
    private searchService: SearchService,

  ) { }

  ngOnInit() {

    this.loadVaInTrash();

    this.searchService.searchInputChange.subscribe((searchText) => {
      var filteredProjects = this.vaService.agents.filter((project) => project.title.toLocaleLowerCase().includes(searchText.toLocaleLowerCase().trim()) || project.sector.toLocaleLowerCase().includes(searchText.toLocaleLowerCase().trim()) || project.client_name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase().trim()))
      this.splitCreatedProject(filteredProjects);
    })

    this.vaService.projectDeleteEvent.subscribe((data) => {
    this.loadVaInTrash();
    })

  }

loadVaInTrash(){
this.loadingStatus =true;
  this.vaService.getArchievedAgents().subscribe((result) => {
    
    var groupedProjectsObject = groupArray(result, 'sector');

  this.groupedProjects = [];
  for (let key in groupedProjectsObject) {
    this.groupedProjects.push({
      sector: key,
      projects: groupedProjectsObject[key]
    })

  }
  this.loadingStatus =false;
  })
}


  private splitCreatedProject(projects) {
  this.loadingStatus =true;

    var groupedProjectsObject = groupArray(projects, 'sector');

    this.groupedProjects = [];
    for (let key in groupedProjectsObject) {
      this.groupedProjects.push({
        sector: key,
        projects: groupedProjectsObject[key]
      })

    }
    this.loadingStatus =false;
  }

  searchInputChanged() {
    this.searchService.searchInputChange.emit(this.searchText);
  }
}
